import { render, staticRenderFns } from "./crearEst.vue?vue&type=template&id=687fce54&scoped=true"
import script from "./crearEst.vue?vue&type=script&lang=js"
export * from "./crearEst.vue?vue&type=script&lang=js"
import style0 from "./crearEst.vue?vue&type=style&index=0&id=687fce54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687fce54",
  null
  
)

export default component.exports